// src/App.js
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider as MUIThemeProvider, CssBaseline, Box } from '@mui/material';
import { ThemeProvider, useTheme } from './context/ThemeContext';
import { AppProviders } from './context/AppContext'; // NUEVO: Auth real (Ecolab JWT)
import { AmbitoProvider } from './context/AmbitoContext';
import Header from './components/layout/Header';
import GlobalAuthErrorModal from './components/GlobalAuthErrorModal';
import AppRoutes from './routes';

const AppContent = () => {
  const { theme } = useTheme();

  return (
    <MUIThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
        <Header />
        <AppRoutes />
        {/* Bloquea toda la app cuando la sesión se rompe de forma no
            recuperable (no autorizado para esta app, expirada,
            inválida) -- ver services/api.js fetchApi(). Una sola vez
            acá, no en cada página. */}
        <GlobalAuthErrorModal />
      </Box>
    </MUIThemeProvider>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AppProviders> {/* NUEVO: Auth real — reemplaza el usersDB en memoria */}
        <AmbitoProvider>
          <ThemeProvider>
            <AppContent />
          </ThemeProvider>
        </AmbitoProvider>
      </AppProviders>
    </BrowserRouter>
  );
}

export default App;
